export const getInitials = ({
  firstName,
  lastName,
  nickname,
}: {
  firstName?: string
  lastName?: string
  nickname?: string | null
}): string =>
  `${
    nickname ? nickname[0] : (firstName?.[0] ?? '') + (lastName?.[0] ?? '')
  }`.toUpperCase()
